import * as AT from './actionTypes'

export type SubmitChangeEmailActionType = {
  type: typeof AT.SUBMIT
}

export type ChangeEmailActionType = SubmitChangeEmailActionType

const submit = (): ChangeEmailActionType => ({
  type: AT.SUBMIT
})

export default { submit }
